// =============================================================================
// GENERATED by scripts/build-shared.cjs from functions/src/shared/timeOffBalance.js
// DO NOT EDIT — edit the canonical file and re-run `node scripts/build-shared.cjs`.
// (TASK-9839: ONE time-off balance + milestone grants — HR tab, driver modal,
// approval text and the grant audit all run the same code.)
//
// Side-effect module: attaches `window.TimeOffBalance`. Views read it at CALL time.
//
// The body below is the canonical file's PORTABLE CORE, copied byte for byte.
// =============================================================================
(function () {
  'use strict';

  var TOB_HOURS_PER_DAY = 8;
  var TOB_DEFAULT_TZ = 'America/Chicago';
  var TOB_MAX_GRANT_RULES = 20;
  var TOB_MAX_AFTER_DAYS = 3660;
  var TOB_MAX_AFTER_MONTHS = 120;
  var TOB_MAX_GRANT_DAYS = 365;
  // Same ids/labels/order as hr.js TIME_OFF_CATEGORIES.
  var TOB_CATEGORIES = [
    { id: 'vacation', label: 'Vacation' },
    { id: 'sick', label: 'Sick Leave' },
    { id: 'personal', label: 'Personal Day' },
    { id: 'unpaid', label: 'Unpaid' },
    { id: 'bereavement', label: 'Bereavement' },
    { id: 'parental_leave', label: 'Parental Leave' },
    { id: 'jury_duty', label: 'Jury Duty' },
    { id: 'other', label: 'Other' }
  ];
  // A grant fills a paid POOL — never unpaid, never per-event bereavement.
  var TOB_GRANT_CATEGORIES = ['vacation', 'sick', 'personal', 'parental_leave', 'jury_duty', 'other'];

  function tobCategoryLabel(id) {
    for (var i = 0; i < TOB_CATEGORIES.length; i++) if (TOB_CATEGORIES[i].id === id) return TOB_CATEGORIES[i].label;
    return 'Other';
  }

  function tobValidIso(s) {
    if (typeof s !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(s)) return false;
    var y = +s.slice(0, 4), m = +s.slice(5, 7), d = +s.slice(8, 10);
    var dt = new Date(Date.UTC(y, m - 1, d));
    return dt.getUTCFullYear() === y && dt.getUTCMonth() === m - 1 && dt.getUTCDate() === d;
  }

  // Realm-safe Date test (a Date made in another frame / vm fails instanceof).
  function tobIsDate(v) {
    return Object.prototype.toString.call(v) === '[object Date]';
  }

  function tobToDate(value) {
    if (value == null || value === '') return null;
    if (tobIsDate(value)) return isNaN(value.getTime()) ? null : value;
    if (typeof value.toDate === 'function') { var d0 = value.toDate(); return (tobIsDate(d0) && !isNaN(d0.getTime())) ? d0 : null; }
    if (typeof value === 'object' && typeof value.seconds === 'number') return new Date(value.seconds * 1000);
    if (typeof value === 'object' && typeof value._seconds === 'number') return new Date(value._seconds * 1000);
    var d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  }

  function tobUsableZone(tz) {
    var z = (typeof tz === 'string' && tz.trim()) ? tz.trim() : TOB_DEFAULT_TZ;
    try { new Intl.DateTimeFormat('en-US', { timeZone: z }); return z; } catch (e) { return TOB_DEFAULT_TZ; }
  }

  // The calendar day a value falls on in `tz`, as 'YYYY-MM-DD' ('' when unknown).
  // A bare 'YYYY-MM-DD' string is already a calendar day and is returned as-is.
  function tobIsoInZone(value, tz) {
    if (typeof value === 'string' && value.length === 10 && tobValidIso(value)) return value;
    var d = tobToDate(value);
    if (!d) return '';
    var parts = new Intl.DateTimeFormat('en-US', { timeZone: tobUsableZone(tz), year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(d);
    var y = '', m = '', dd = '';
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].type === 'year') y = parts[i].value;
      else if (parts[i].type === 'month') m = parts[i].value;
      else if (parts[i].type === 'day') dd = parts[i].value;
    }
    var iso = y + '-' + m + '-' + dd;
    return tobValidIso(iso) ? iso : '';
  }

  function tobAddDays(iso, n) {
    var dt = new Date(Date.UTC(+iso.slice(0, 4), +iso.slice(5, 7) - 1, +iso.slice(8, 10)));
    dt.setUTCDate(dt.getUTCDate() + n);
    return dt.toISOString().slice(0, 10);
  }

  // Calendar months; a day past the end of the target month clamps to its last
  // day (hired Aug 31 + 6 months = Feb 28/29).
  function tobAddMonths(iso, n) {
    var y = +iso.slice(0, 4), m = +iso.slice(5, 7) - 1 + n, d = +iso.slice(8, 10);
    var ty = y + Math.floor(m / 12), tm = ((m % 12) + 12) % 12;
    var last = new Date(Date.UTC(ty, tm + 1, 0)).getUTCDate();
    return new Date(Date.UTC(ty, tm, Math.min(d, last))).toISOString().slice(0, 10);
  }

  function tobFmtDays(n) {
    var r = Math.round(n * 100) / 100;
    return r + ' day' + (r === 1 ? '' : 's');
  }

  // Validated copy of a level's grant rules. Anything malformed is DROPPED, never
  // guessed: a rule with no days, an unknown kind/unit/category or an absurd
  // "after" contributes nothing.
  function tobNormalizeGrantRules(raw) {
    if (!Array.isArray(raw)) return [];
    var out = [];
    for (var i = 0; i < raw.length && out.length < TOB_MAX_GRANT_RULES; i++) {
      var r = raw[i];
      if (!r || typeof r !== 'object') continue;
      var kind = r.kind === 'yearly' ? 'yearly' : (r.kind === 'once' ? 'once' : '');
      var unit = r.unit === 'months' ? 'months' : (r.unit === 'days' ? 'days' : '');
      var after = Number(r.after);
      var days = Number(r.days);
      var category = String(r.category || '');
      if (!kind || !unit) continue;
      if (!isFinite(after) || after < 0 || Math.floor(after) !== after) continue;
      if (after > (unit === 'months' ? TOB_MAX_AFTER_MONTHS : TOB_MAX_AFTER_DAYS)) continue;
      if (!isFinite(days) || days <= 0 || days > TOB_MAX_GRANT_DAYS) continue;
      if (TOB_GRANT_CATEGORIES.indexOf(category) < 0) continue;
      var id = (typeof r.id === 'string' && /^[A-Za-z0-9_-]{1,40}$/.test(r.id)) ? r.id : ('g' + i);
      out.push({ id: id, kind: kind, after: after, unit: unit, days: days, category: category });
    }
    return out;
  }

  function tobRuleReachedOn(hireIso, rule) {
    return rule.unit === 'months' ? tobAddMonths(hireIso, rule.after) : tobAddDays(hireIso, rule.after);
  }

  // Plain-English "why" for a rule: "90 days after hire", "New year (after 6 months)".
  function tobRuleReason(rule) {
    var span = rule.after + ' ' + (rule.unit === 'months' ? (rule.after === 1 ? 'month' : 'months') : (rule.after === 1 ? 'day' : 'days'));
    if (rule.kind === 'yearly') return rule.after === 0 ? 'Every Jan 1 after hire' : ('Every Jan 1 once past ' + span);
    return rule.after === 0 ? 'On hire' : (span + ' after hire');
  }

  function tobRuleSummary(rule) {
    return '+' + tobFmtDays(rule.days) + ' ' + tobCategoryLabel(rule.category) + ' — ' + tobRuleReason(rule);
  }

  // Every grant a person has received through `throughIso` (landed) plus the
  // next one each rule will give (upcoming). Dates are tenant calendar days.
  function tobGrantsForPerson(hireIso, rules, throughIso) {
    var landed = [], upcoming = [];
    if (!tobValidIso(hireIso) || !tobValidIso(throughIso)) return { landed: landed, upcoming: upcoming };
    var list = tobNormalizeGrantRules(rules);
    var throughYear = +throughIso.slice(0, 4);
    for (var i = 0; i < list.length; i++) {
      var rule = list[i];
      var reached = tobRuleReachedOn(hireIso, rule);
      var base = { ruleId: rule.id, kind: rule.kind, category: rule.category, categoryLabel: tobCategoryLabel(rule.category),
        days: rule.days, hours: rule.days * TOB_HOURS_PER_DAY, reason: tobRuleReason(rule) };
      if (rule.kind === 'once') {
        var g = Object.assign({}, base, { on: reached, year: +reached.slice(0, 4) });
        if (reached <= throughIso) landed.push(g); else upcoming.push(g);
        continue;
      }
      // yearly: first Jan 1 on or after `reached`.
      var ry = +reached.slice(0, 4);
      var firstYear = reached.slice(5) === '01-01' ? ry : ry + 1;
      for (var y = firstYear, n = 0; y <= throughYear && n < 200; y++, n++) {
        landed.push(Object.assign({}, base, { on: y + '-01-01', year: y }));
      }
      var nextYear = Math.max(firstYear, throughYear + 1);
      upcoming.push(Object.assign({}, base, { on: nextYear + '-01-01', year: nextYear }));
    }
    var byDate = function (a, b) { return a.on < b.on ? -1 : (a.on > b.on ? 1 : (a.ruleId < b.ruleId ? -1 : 1)); };
    landed.sort(byDate);
    upcoming.sort(byDate);
    return { landed: landed, upcoming: upcoming };
  }

  // ---- request day math (same rules as hr.js enumerateRequestDays /
  // hoursPerDayForRequest: days are stored at noon, so a request's days are its
  // UTC date parts; per-day types in dayTypes; excludedDates count for nothing).
  function tobRequestDays(req) {
    if (!req) return [];
    var start = tobToDate(req.startDate), end = tobToDate(req.endDate);
    if (!start || !end) return [];
    var cur = new Date(Date.UTC(start.getUTCFullYear(), start.getUTCMonth(), start.getUTCDate()));
    var stop = new Date(Date.UTC(end.getUTCFullYear(), end.getUTCMonth(), end.getUTCDate()));
    var baseType = req.type || 'unpaid';
    var dayTypes = (req.dayTypes && typeof req.dayTypes === 'object') ? req.dayTypes : {};
    var excluded = Array.isArray(req.excludedDates) ? req.excludedDates : [];
    var out = [];
    for (var n = 0; cur <= stop && n < 1000; n++) {
      var iso = cur.toISOString().slice(0, 10);
      out.push({ iso: iso, type: Object.prototype.hasOwnProperty.call(dayTypes, iso) ? dayTypes[iso] : baseType, isExcluded: excluded.indexOf(iso) >= 0 });
      cur.setUTCDate(cur.getUTCDate() + 1);
    }
    return out;
  }

  function tobHoursPerDay(req) {
    var days = tobRequestDays(req);
    if (days.length > 0 && req && req.hours) return req.hours / days.length;
    return TOB_HOURS_PER_DAY;
  }

  // Id first; the name fallback applies ONLY to legacy rows that carry no id.
  function tobRequestIsFor(req, personId, personName) {
    if (!req || !personId) return false;
    if (req.personId === personId || req.employeeId === personId) return true;
    if (req.personId || req.employeeId) return false;
    return !!personName && (req.personName === personName || req.employeeName === personName);
  }

  // Accrual (same math as hr.js calculateAccruedHours, with its inputs passed in).
  function tobAccruedHours(entry, year, ctx) {
    ctx = ctx || {};
    // Tenant-local calendar: with ctx.todayIso every date is built from date
    // parts in UTC, so the browser and the server count the same periods.
    var msNow, msYearStart, month, date;
    if (tobValidIso(ctx.todayIso)) {
      month = +ctx.todayIso.slice(5, 7) - 1; date = +ctx.todayIso.slice(8, 10);
      msNow = Date.UTC(+ctx.todayIso.slice(0, 4), month, date);
      msYearStart = Date.UTC(year, 0, 1);
    } else {
      var now = tobIsDate(ctx.now) ? ctx.now : new Date();
      month = now.getMonth(); date = now.getDate();
      msNow = now.getTime(); msYearStart = new Date(year, 0, 1).getTime();
    }
    var rate = entry.rate || 0;
    if (entry.method === 'per_pay_period') {
      var pp = ctx.payPeriodType || 'biweekly';
      var periods = 0;
      if (pp === 'weekly') periods = Math.floor((msNow - msYearStart) / (7 * 86400000));
      else if (pp === 'biweekly') periods = Math.floor((msNow - msYearStart) / (14 * 86400000));
      else if (pp === 'semimonthly') periods = month * 2 + (date > 15 ? 2 : 1);
      else if (pp === 'monthly') periods = month + (date > 1 ? 1 : 0);
      return periods * rate;
    }
    if (entry.method === 'per_hours_worked') {
      var hw = (typeof ctx.hoursWorked === 'number' && !isNaN(ctx.hoursWorked)) ? ctx.hoursWorked : 0;
      return Math.floor(hw / (entry.rateBase || 40)) * rate;
    }
    return 0;
  }

  // True when this person's plan needs their clock hours (per-hours-worked accrual).
  function tobNeedsClockHours(person, policy) {
    if (!person || !policy || !Array.isArray(policy.levels)) return false;
    var level = null;
    for (var i = 0; i < policy.levels.length; i++) if (policy.levels[i] && policy.levels[i].id === person.hrTimeOffLevel) level = policy.levels[i];
    var al = level && person.hrEmploymentType ? (level[person.hrEmploymentType] || {}) : {};
    var ac = al._accrual || {};
    for (var k in ac) if (Object.prototype.hasOwnProperty.call(ac, k) && ac[k] && ac[k].method === 'per_hours_worked') return true;
    return false;
  }

  // THE balance. opts: { personId, year, tz, todayIso, now, payPeriodType,
  // clockHours }. Returns { status: 'ok', level, empType, year, todayIso,
  // hireIso, categories, rows: [{ id, label, earned, used, remaining,
  // methodLabel, grantHours }], used, approvedRequests, grants: { rules,
  // landed, thisYear, upcoming }, needsClockHours } or { status: 'no_employee' |
  // 'no_policy' | 'no_employment_type' | 'no_level' | 'level_missing' }.
  function tobComputeBalances(person, policy, requests, opts) {
    opts = opts || {};
    if (!person) return { status: 'no_employee' };
    if (!policy || !Array.isArray(policy.levels) || !policy.levels.length) return { status: 'no_policy' };
    if (!person.hrEmploymentType) return { status: 'no_employment_type' };
    if (!person.hrTimeOffLevel) return { status: 'no_level' };
    var level = null;
    for (var li = 0; li < policy.levels.length; li++) if (policy.levels[li] && policy.levels[li].id === person.hrTimeOffLevel) level = policy.levels[li];
    if (!level) return { status: 'level_missing' };

    var tz = tobUsableZone(opts.tz);
    var now = tobIsDate(opts.now) ? opts.now : new Date();
    var todayIso = tobValidIso(opts.todayIso) ? opts.todayIso : tobIsoInZone(now, tz);
    var year = opts.year || +todayIso.slice(0, 4);
    var personId = opts.personId || person.id;
    var empType = person.hrEmploymentType;
    var allowances = level[empType] || {};
    var accrualConfig = allowances._accrual || {};

    // A request counts in the year of each of ITS DAYS (Dec 31 - Jan 2 charges
    // one day to the old year and two to the new), not all to its start year.
    var yearPrefix = String(year) + '-';
    var approvedRequests = (Array.isArray(requests) ? requests : []).filter(function (r) {
      if (!tobRequestIsFor(r, personId, person.name)) return false;
      if (r.status !== 'approved') return false;
      return tobRequestDays(r).some(function (d) { return d.iso.indexOf(yearPrefix) === 0; });
    });

    var used = {};
    approvedRequests.forEach(function (r) {
      var hpd = tobHoursPerDay(r);
      tobRequestDays(r).forEach(function (d) {
        if (d.isExcluded) return;
        if (d.iso.indexOf(yearPrefix) !== 0) return;
        var t = d.type || 'other';
        used[t] = (used[t] || 0) + hpd;
      });
    });

    // Grants: derived from the hire date in the tenant's zone, counted in the
    // calendar year they land (never later than today).
    var rules = tobNormalizeGrantRules(level.grants);
    var hireIso = tobIsoInZone(person.hireDate, tz);
    var all = rules.length && hireIso ? tobGrantsForPerson(hireIso, rules, todayIso) : { landed: [], upcoming: [] };
    var thisYear = all.landed.filter(function (g) { return g.year === year; });
    var grantHours = {};
    thisYear.forEach(function (g) { grantHours[g.category] = (grantHours[g.category] || 0) + g.hours; });

    var categories = TOB_CATEGORIES.filter(function (c) {
      if (c.id === 'bereavement') return false;
      if (c.id === 'unpaid' && empType === 'salary') return false;
      return true;
    });

    var ctx = { now: now, todayIso: todayIso, payPeriodType: opts.payPeriodType, hoursWorked: opts.clockHours };
    var rows = categories.map(function (cat) {
      var ac = accrualConfig[cat.id];
      var earned, methodLabel = '';
      if (ac && ac.method && ac.method !== 'annual') {
        earned = tobAccruedHours(ac, year, ctx);
        if (ac.cap != null) earned = Math.min(earned, ac.cap);
        methodLabel = ac.method === 'per_pay_period' ? ' (per period)' : ' (per hrs worked)';
      } else {
        earned = (Number(allowances[cat.id]) || 0) * TOB_HOURS_PER_DAY;
      }
      var gh = grantHours[cat.id] || 0;
      if (gh) { earned += gh; methodLabel += ' (incl. milestones)'; }
      var u = used[cat.id] || 0;
      return { id: cat.id, label: cat.label, earned: earned, used: u, remaining: earned - u, methodLabel: methodLabel, grantHours: gh };
    });

    return {
      status: 'ok', level: level, empType: empType, year: year, todayIso: todayIso, hireIso: hireIso,
      categories: categories, rows: rows, used: used, approvedRequests: approvedRequests,
      grants: { rules: rules, landed: all.landed, thisYear: thisYear, upcoming: all.upcoming },
      needsClockHours: tobNeedsClockHours(person, policy)
    };
  }

  // TASK-9838 — does this person have a time-off plan? Only when their level
  // exists in the company's plan. No plan, no level, or a level the plan no
  // longer has = no plan: the request forms offer Unpaid only (Chris 10/13).
  // Employment type is deliberately NOT required here — it decides the balance
  // numbers, not whether the person is on a plan.
  function tobHasPlan(person, policy) {
    var levelId = person && person.hrTimeOffLevel;
    if (!levelId || !policy || !Array.isArray(policy.levels)) return false;
    for (var i = 0; i < policy.levels.length; i++) if (policy.levels[i] && policy.levels[i].id === levelId) return true;
    return false;
  }

  // TASK-9838 — "Unpaid time off taken in <year>: N hrs" on the driver modal.
  // Approved requests for this person only; each DAY counts in its own year
  // (a request across Jan 1 splits); only days already past (before today in
  // the tenant's zone — approved future leave is not "taken"); excluded days
  // count for nothing; a per-day type decides the day (an unpaid day inside a
  // vacation request counts, a vacation day inside an unpaid one does not).
  // Hours per day = the same tobHoursPerDay HR uses, so past + future here
  // equals the HR tab's used.unpaid for the year. opts: { personId, tz,
  // todayIso, now, year }. Returns { year, todayIso, hours }.
  function tobUnpaidTakenHours(person, requests, opts) {
    opts = opts || {};
    var tz = tobUsableZone(opts.tz);
    var now = tobIsDate(opts.now) ? opts.now : new Date();
    var todayIso = tobValidIso(opts.todayIso) ? opts.todayIso : tobIsoInZone(now, tz);
    var year = opts.year || +todayIso.slice(0, 4);
    var yearPrefix = String(year) + '-';
    var personId = opts.personId || (person && person.id);
    var personName = person && person.name;
    var hours = 0;
    (Array.isArray(requests) ? requests : []).forEach(function (r) {
      if (!tobRequestIsFor(r, personId, personName)) return;
      if (!r || r.status !== 'approved') return;
      var hpd = tobHoursPerDay(r);
      tobRequestDays(r).forEach(function (d) {
        if (d.isExcluded) return;
        if (d.type !== 'unpaid') return;
        if (d.iso.indexOf(yearPrefix) !== 0) return;
        if (!(d.iso < todayIso)) return;
        hours += hpd;
      });
    });
    return { year: year, todayIso: todayIso, hours: Math.round(hours * 100) / 100 };
  }

  window.TimeOffBalance = Object.freeze({
    HOURS_PER_DAY: TOB_HOURS_PER_DAY,
    DEFAULT_TZ: TOB_DEFAULT_TZ,
    MAX_GRANT_RULES: TOB_MAX_GRANT_RULES,
    CATEGORIES: TOB_CATEGORIES,
    GRANT_CATEGORIES: TOB_GRANT_CATEGORIES,
    categoryLabel: tobCategoryLabel,
    validIso: tobValidIso,
    isoInZone: tobIsoInZone,
    addDays: tobAddDays,
    addMonths: tobAddMonths,
    normalizeGrantRules: tobNormalizeGrantRules,
    ruleReachedOn: tobRuleReachedOn,
    ruleReason: tobRuleReason,
    ruleSummary: tobRuleSummary,
    grantsForPerson: tobGrantsForPerson,
    requestDays: tobRequestDays,
    hoursPerDay: tobHoursPerDay,
    requestIsFor: tobRequestIsFor,
    accruedHours: tobAccruedHours,
    needsClockHours: tobNeedsClockHours,
    computeBalances: tobComputeBalances,
    hasPlan: tobHasPlan,
    unpaidTakenHours: tobUnpaidTakenHours
  });
})();
